import React, { FC } from 'react';

interface HtmlRenderProps extends React.HTMLProps<HTMLDivElement> {
  html: string;
  element?: keyof JSX.IntrinsicElements;
}

const HtmlRender: FC<HtmlRenderProps> = ({ html, element: HtmlTag = 'div', ...rest }) => {
  return <HtmlTag dangerouslySetInnerHTML={{ __html: html }} {...rest} />;
};

export default HtmlRender;
